import React from "react";
import ProfileContainer from "@commr/admin/components/users/profileContainer";

const ProfilePage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <ProfileContainer />
);

export default ProfilePage;
